import { RootState } from 'store';

const RejectedState = (state: RootState) => state.weeklyPlanner.rejected;

export const selectAll = (state: RootState) => RejectedState(state).rows;
export const selectLoading = (state: RootState) => RejectedState(state).loading;
export const selectHasLoaded = (state: RootState) => RejectedState(state).hasLoaded;
export const selectParams = (state: RootState) => RejectedState(state).params;
export const selectCount = (state: RootState) => RejectedState(state).count;
